"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.passLabelProps = exports.labelProps = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HelpHint = _interopRequireDefault(require("../tooltips/HelpHint"));

var _underscore = require("underscore");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/** @class FormLabel
 * @desc Most form fields implement the same logic to display an optional label, with optional hint.
 * It is easier to consolidate this logic in one component to avoid re-inventing the wheel.
 * This component displays the value provided as prop, if provided. Next to it, it displays its children.
 * If there is no value and no children, nothing is rendered.
 *
 * @param {string} [data-id="formLabel"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {boolean} [detached=false]
 *     When true, detached styling is applied. For use when label is used when not bundled with an input
 * @param {string} [value]
 *     The label text.  If omitted and if this element has no children, nothing is rendered.
 * @param {node} [hint]
 *     The hint text either a string or a JSX object. If omitted, the help hint is not rendered.
 * @param {string} [lockText]
 *     The lock text. If omitted, the lock hint is not rendered.
 * @param {HelpHint.Placements} [helpPlacement]
 *     How to place the help hint.
 * @param {object} [helpTarget]
 *     An optional icon or image to replace standard help hint icon
 * @param {object} [style]
 *     For passing through direct style attribute from parent
 * @param {node} [description]
 *     The text to display below the title. Can be a string or a node.
 * @param {node} [explanation]
 *     Explanation text for the field appears below it.
 * @param {boolean} [noSpacing=false]
 *     Remove margin
 */
var labelProps = {
  description: _propTypes.default.node,
  explanation: _propTypes.default.node,
  helpClassName: _propTypes.default.string,
  helpPlacement: _propTypes.default.oneOf((0, _values.default)(_HelpHint.default.placements)),
  helpTarget: _propTypes.default.object,
  hint: _propTypes.default.node,
  lockText: _propTypes.default.string,
  noSpacing: _propTypes.default.bool
};
exports.labelProps = labelProps;

var passLabelProps = function passLabelProps(props) {
  return (0, _underscore.pick)(props, (0, _keys.default)(labelProps));
};

exports.passLabelProps = passLabelProps;

var FormLabel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormLabel, _React$Component);

  var _super = _createSuper(FormLabel);

  function FormLabel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FormLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderHint", function () {
      if (!_this.props.hint) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
        ref: "hint",
        "data-id": "help-tooltip",
        className: (0, _classnames.default)("inline", _this.props.helpClassName),
        placement: _this.props.helpPlacement,
        hintText: _this.props.hint
      }, _this.props.helpTarget);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderLockHint", function () {
      if (!_this.props.lockText) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
        ref: "lock",
        "data-id": "lock-tooltip",
        className: (0, _classnames.default)("inline", _this.props.helpClassName),
        hintText: _this.props.lockText,
        placement: _this.props.helpPlacement,
        lock: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderDescriptionText", function () {
      if (_this.props.description) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "label-text__description"
        }, _this.props.description);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FormLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          dataId = _this$props["data-id"],
          detached = _this$props.detached,
          explanation = _this$props.explanation,
          noSpacing = _this$props.noSpacing,
          style = _this$props.style,
          value = _this$props.value;
      var noLabel = typeof value === "undefined" || value === null;

      if (noLabel && !children) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("label", {
        "data-id": dataId,
        className: (0, _classnames.default)("form-label", className, {
          detached: detached,
          "form-label--no-spacing": noSpacing
        }),
        style: style
      }, !noLabel && /*#__PURE__*/_react.default.createElement("span", {
        className: "label-text",
        "data-id": "label"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "label-container"
      }, value, this._renderHint(), this._renderLockHint()), this._renderDescriptionText()), children, explanation && /*#__PURE__*/_react.default.createElement("div", {
        className: "form-label__explanation"
      }, explanation));
    }
  }]);
  return FormLabel;
}(_react.default.Component);

(0, _defineProperty2.default)(FormLabel, "propTypes", _objectSpread({
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  detached: _propTypes.default.bool,
  style: _propTypes.default.object,
  value: _propTypes.default.node
}, labelProps));
(0, _defineProperty2.default)(FormLabel, "defaultProps", {
  "data-id": "formLabel",
  detached: false,
  noSpacing: false,
  style: {}
});
var _default = FormLabel;
exports.default = _default;